import { CardMedia, Stack, Typography } from "@mui/material";
import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import img from "../../img/CWTA.webp";

const Benifits = ({ ComponentData, index }) => {
  // const benifits = [
  //   { title: "Seamless transition from ads to chat." },
  //   { title: "Social media ads redirect to WhatsApp." },
  //   { title: "Boost conversions with direct interaction." },
  //   { title: "Precise targeting for high ROAS." },
  //   { title: "Lead generation with WhatsApp chats." },
  //   { title: "Enhance customer journey through WhatsApp." },
  //   { title: "Enhance journey through WhatsApp." },
  //   { title: "Enhance journey through WhatsApp." },
  // ];
  // console.log("ComponentData[0]?.benifits:", ComponentData[0]?.benifits);
  const benifits = ComponentData[index]?.benifits?.benifits_list;

  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: { xs: "28px", sm: "0px", md: "32px", lg: "32px", xl: "0px"},
        marginTop: { xs: "28px", sm: "0px", md: "32px", lg: "32px", xl: "0px" },
      }}
    >
      <Stack
        sx={{
          //   border: "1px solid red",
          // width: { xs: "100%", sm: "73%", xl: "73%", lg: "73%", md: "88%" },
          width: { xl: "72%", lg: "89%", md: "89%", sm: "100%", xs: "92%" },
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          gap: 2,
        }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { xs: "100%", sm: "60%" },
            // border: "1px solid green",
          }}
        >
          <Stack
            sx={{
              // border: "1px solid red",
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Stack
              sx={{
                fontFamily: "'Roboto', sans-serif",
                fontSize: {
                  xs: "24px",
                  sm: "32px",
                  md: "32px",
                  lg: "48px",
                  xl: "48px",
                },
                lineHeight: {
                  xs: "32px",
                  sm: "38px",
                  md: "38px",
                  lg: "52px",
                  xl: "52px",
                },
                fontWeight: 600,
                color: "rgb(5 78 146)",
                textAlign: "center",
                // border: "1px solid red",
                display: "flex",
                flexDirection: "row",
                marginBottom: {
                  xs: "20px",
                  sm: "20px",
                  md: "20px",
                  lg: "20px",
                  xl: "20px",
                },
              }}
            >
              <Stack
                sx={{
                  // border: "1px solid red",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Stack
                  sx={{
                    width: { xl: "6px", lg: "6px", xs: "4px" },
                    // height: { xl: "100%", lg: "100%", xs: "100%" },
                    height: {
                      xs: "20px",
                      sm: "44px",
                      md: "28px",
                      lg: "40px",
                      xl: "40px",
                    },
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    border: "1px solid rgb(5 78 146)",
                    // backgroundColor: "rgb(5 78 146)",
                    backgroundColor: "rgb(5 78 146)",
                    marginRight: {
                      xs: "8px",
                      sm: "8px",
                      md: "12px",
                      lg: "12px",
                      xl: "12px",
                    },

                    borderTopRightRadius: "8px", // Adjust the value as needed
                    borderBottomRightRadius: "8px", // Adjust the value as needed
                  }}
                >
                  <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
                </Stack>
              </Stack>
              <span style={{ display: "inline-flex", alignItems: "center" }}>
                Benifits
              </span>
            </Stack>

            <Stack
              sx={{
                width: "100%",
                fontFamily: "'Roboto', sans-serif",
                fontSize: {
                  xs: "16px",
                  sm: "16px",
                  md: "16px",
                  lg: "24px",
                  xl: "24px",
                },
                lineHeight: {
                  xs: "24px",
                  sm: "28px",
                  md: "32px",
                  lg: "32px",
                  xl: "32px",
                },
                fontWeight: { xs: 400, sm: 400, md: 400, lg: 400, xl: 400 },
                color: "#333",
                border: "1px solid #f1f8ff",
                textAlign: "left",
                // border: "1px solid rgb(218 233 248)",
                padding: 1,
                borderRadius: "8px",
                backgroundColor: "#f1f8ff",
                marginBottom: {
                  xs: "20px",
                  sm: "20px",
                  md: "20px",
                  lg: "20px",
                  xl: "20px",
                },
              }}
            >
              {/* Find quick answers about Vertex Suite WhatsApp Business Platform. Learn how automation works, what templates you can use. */}
              {ComponentData[index]?.benifits?.card_head2}
            </Stack>

            <Stack sx={{ gap: 2, marginBottom: { xs: "16px", sm: "0px" } }}>
              {benifits.map((item, index) => (
                <Stack
                  key={index}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                >
                  <FaCheckCircle color="green" size={16} />
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: "'Roboto', sans-serif",
                      fontSize: {
                        xs: "16px",
                        sm: "20px",
                        md: "20px",
                        lg: "20px",
                        xl: "20px",
                      },
                      lineHeight: {
                        xs: "20px",
                        sm: "24px",
                        md: "24px",
                        lg: "24px",
                        xl: "24px",
                      },
                      fontWeight: 400,
                      color: "rgb(128, 128, 128)",
                      // border: "1px solid red",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </Stack>
        <Stack
          sx={{
            display: "flex",
            flexDirection: "column",
            width: { xs: "100%", sm: "40%" },
          }}
        >
          <CardMedia
            component="img"
            // image={img}
            image={ComponentData[index]?.benifits?.card_image}
            alt="img.png"
            sx={{ height: "100%", width: "100%" }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default Benifits;
